import PaymentPlanTwoFactorAuthenticationError from './PaymentPlanTwoFactorAuthenticationError';
class ChannelIsNotSupported extends PaymentPlanTwoFactorAuthenticationError {
    channel;
    constructor(channel, options) {
        super('Channel is not supperted', options);
        this.channel = channel;
    }
}
export default ChannelIsNotSupported;
